import { render, staticRenderFns } from "./QScoreCardUniqueLeadTakers.vue?vue&type=template&id=2e556538&scoped=true&"
import script from "./QScoreCardUniqueLeadTakers.vue?vue&type=script&lang=js&"
export * from "./QScoreCardUniqueLeadTakers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e556538",
  null
  
)

export default component.exports